import {Brick, ListDef, QueryResult, registerBrick} from 'olympe';

/**
 * Convert a list (ListDef, QueryResult) or a collection (Map, string, ...) to a vanilla array.
 * If conversion is not possible, returns an empty array.
 *
 * This function is not realtime with ListDef, it takes the current values.
 */
export default class ToArray extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} collection
     * @param {function(!Array)} setArray
     */
    update($, [collection], [setArray]) {
        // If collection is an array, pass-through
        if (Array.isArray(collection)) {
            setArray(collection);
        } else if (collection instanceof QueryResult) { // If the collection is a QueryResult, use toArray()
            setArray(collection.toArray());
        } else if (collection instanceof ListDef) { // If the collection is a ListDef, build array from current values
            const array = [];
            collection.forEachCurrentValue((value) => array.push(value));
            setArray(array);
        } else { // None of above, use Array.from()
            setArray(Array.from(collection));
        }
    }
}

registerBrick('0197694ec9f395476049', ToArray);
